import { css } from '@emotion/css';

export const formContainerStyles = css`
  padding-bottom: 8rem;
`;

export const modalHeaderStyles = css`
  padding-top: 2.4rem;
`;
